import React, { PropTypes } from 'react';

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.
class App extends React.Component {
  render() {
    return (
      <main>
        {this.props.children}
      </main>
    );
  }
}

App.propTypes = {
  children: PropTypes.element
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js